module.exports = __webpack_public_path__ + "img/2.451df7fe.png";